import { useQuery } from "@tanstack/react-query";

interface SiteMode {
  prelaunch: boolean;
}

/**
 * Whether the site is in pre-launch (coming soon) mode.
 *
 * The server owns the flag (PRELAUNCH_MODE env var) so launch day is a config
 * flip, no rebuild. While the request is in flight we assume prelaunch=true:
 * the safe failure mode is briefly showing "Join Waitlist" after launch, never
 * briefly showing "Start Free Trial" before it.
 */
export function usePrelaunch(): boolean {
  const { data } = useQuery<SiteMode>({
    queryKey: ["/api/site-mode"],
    queryFn: async () => {
      const res = await fetch("/api/site-mode");
      if (!res.ok) return { prelaunch: true };
      return res.json();
    },
    staleTime: Infinity,
    placeholderData: { prelaunch: true },
  });

  return data?.prelaunch ?? true;
}
